import { render, staticRenderFns } from "./ChannelManagerRequestsChart.vue?vue&type=template&id=06dc4868&"
import script from "./ChannelManagerRequestsChart.vue?vue&type=script&lang=js&"
export * from "./ChannelManagerRequestsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06dc4868')) {
      api.createRecord('06dc4868', component.options)
    } else {
      api.reload('06dc4868', component.options)
    }
    module.hot.accept("./ChannelManagerRequestsChart.vue?vue&type=template&id=06dc4868&", function () {
      api.rerender('06dc4868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/ChannelManagerRequestsChart.vue"
export default component.exports